import { useRef } from 'react';
import { useActiveLab, useLabKeypointTypes } from '@witmetrics/data-store';
import { isEmpty } from '@witmetrics/utils/misc';
import { useToggle } from '@/hooks/useToggle';
import IconButton from '@/components/IconButton';
import { AddIcon, EditIcon, LocationIcon } from '@/icons';
import Menu, { MenuItem } from '@/components/Menu';

export type TimelineMenuProps = {
  onAddNote: () => void;
  onAddKeypoint: () => void;
};

export default function TimelineMenu({
  onAddNote,
  onAddKeypoint,
}: TimelineMenuProps) {
  const menuToggleRef = useRef(null);
  const activeLab = useActiveLab();
  const keypointTypes = useLabKeypointTypes();
  const [isMenuOpen, toggleMenu] = useToggle();

  const handleNewNote = () => {
    onAddNote();
    toggleMenu(false);
  };

  const handleNewKeypoint = () => {
    onAddKeypoint();
    toggleMenu(false);
  };

  return (
    <>
      <IconButton ref={menuToggleRef} onClick={() => toggleMenu()}>
        <AddIcon />
      </IconButton>
      {isMenuOpen && (
        <Menu
          anchorTo={menuToggleRef.current}
          open
          onClose={() => toggleMenu(false)}>
          <MenuItem
            label="Add Note"
            icon={<EditIcon />}
            onClick={handleNewNote}
          />
          {activeLab && !isEmpty(keypointTypes) && (
            <MenuItem
              label="Add Keypoint"
              icon={<LocationIcon />}
              onClick={handleNewKeypoint}
            />
          )}
        </Menu>
      )}
    </>
  );
}
